// update along with app/lib/enums/task.py
const TaskStatus = {
  QUEUED: 'QUEUED',
  PROCESSING: 'PROCESSING',
  DONE: 'DONE',
  ERROR: 'ERROR',
  KILLED: 'KILLED',
};

const TaskStatusOptions = [
  { value: TaskStatus.QUEUED, label: 'QUEUED' },
  { value: TaskStatus.PROCESSING, label: 'PROCESSING' },
  { value: TaskStatus.DONE, label: 'DONE' },
  { value: TaskStatus.ERROR, label: 'ERROR' },
  { value: TaskStatus.KILLED, label: 'KILLED' },
];

const TaskType = {
  ATTRIBUTE_ASSIGNMENT: 'ATTRIBUTE_ASSIGNMENT',
  ATTRIBUTE_EXPORT_FOR_PRODUCT_LIST: 'ATTRIBUTE_EXPORT_FOR_PRODUCT_LIST',
  ATTRIBUTE_EXPORT_TO_SNOWFLAKE_S3: 'ATTRIBUTE_EXPORT_TO_SNOWFLAKE_S3',
  ATTRIBUTE_MIGRATION: 'ATTRIBUTE_MIGRATION',
  ATTRIBUTE_SCHEMA_ASSIGNMENT: 'ATTRIBUTE_SCHEMA_ASSIGNMENT',
  ASSIGN_THUMBNAILS: 'ASSIGN_THUMBNAILS',
  BATCH_ATTRIBUTE_PROPAGATION_REQUEST: 'BATCH_ATTRIBUTE_PROPAGATION_REQUEST',
  BROKEN_IMAGE_DELETE: 'BROKEN_IMAGE_DELETE',
  CACHE_CLEAR_FOR_BRAND_STATUS_UPDATE: 'CACHE_CLEAR_FOR_BRAND_STATUS_UPDATE',
  CACHE_CLEAR_FOR_VENDOR_OVERRIDE_FROM_MFR_CHANGED:
    'CACHE_CLEAR_FOR_VENDOR_OVERRIDE_FROM_MFR_CHANGED',
  CACHE_CLEAR_FOR_VENDOR_TRUSTED_SOURCE_UPDATE: 'CACHE_CLEAR_FOR_VENDOR_TRUSTED_SOURCE_UPDATE',
  CD_DATA_IMPORT: 'CD_DATA_IMPORT',
  DATA_EXPORT_TO_C_N_D: 'DATA_EXPORT_TO_C_N_D',
  DATA_SOURCE_PREPROCESSED_EXPORT: 'DATA_SOURCE_PREPROCESSED_EXPORT',
  DATA_SOURCE_SYNC: 'DATA_SOURCE_SYNC',
  DATA_SOURCE_RECURRING_SYNC: 'DATA_SOURCE_RECURRING_SYNC',
  DEMO_CATALOG_CREATION: 'DEMO_CATALOG_CREATION',
  INTEGRATION_EXPORT: 'INTEGRATION_EXPORT',
  IMAGE_CLEANUP: 'IMAGE_CLEANUP',
  NUTRITION_PANEL_UPLOAD: 'NUTRITION_PANEL_UPLOAD',
  P0_SYNC_TO_C_AND_D: 'P0_SYNC_TO_C_AND_D',
  PRODUCT_LINK_FROM_CHAINS: 'PRODUCT_LINK_FROM_CHAINS',
  PRODUCT_LIST_METRIC_COUNT: 'PRODUCT_LIST_METRIC_COUNT',
  PRODUCT_STATUS_UPDATE: 'PRODUCT_STATUS_UPDATE',
  REFRESH_CACHE_FOR_PRODUCT_LIST: 'REFRESH_CACHE_FOR_PRODUCT_LIST',
  STATS_CALCULATION: 'STATS_CALCULATION',
  UPB_PRODUCT_SCORE_UPDATE: 'UPB_PRODUCT_SCORE_UPDATE',
  INDEXING_ATTRIBUTE_VALUES: 'INDEXING_ATTRIBUTE_VALUES',
  ASSIGNING_UPB_SKUS: 'ASSIGNING_UPB_SKUS',
  MANUFACTURER_PRODUCT_CREATION: 'MANUFACTURER_PRODUCT_CREATION',
  CD_THUMBNAIL_EXPORT: 'CD_THUMBNAIL_EXPORT',
  CONVERTING_MFR_PRODUCTS_TO_DISTRIBUTOR_PRODUCTS:
    'CONVERTING_MFR_PRODUCTS_TO_DISTRIBUTOR_PRODUCTS',
  INDEX_MFR_PRODUCTS: 'INDEX_MFR_PRODUCTS',
  MANUFACTURER_PRODUCT_ENRICHMENT_EXPORT: 'MANUFACTURER_PRODUCT_ENRICHMENT_EXPORT',
  ATTRIBUTE_EXPORT_FOR_DATA_SOURCE: 'ATTRIBUTE_EXPORT_FOR_DATA_SOURCE',
  GDSN_MONITOR: 'GDSN_MONITOR',
  DASHBOARD_WIDGET_CALCULATION: 'DASHBOARD_WIDGET_CALCULATION',
  CACHE_CLEAR_FOR_MULTIPLE_MANUFACTURERS_BRANDS_STATUS_UPDATE_BULK:
    'CACHE_CLEAR_FOR_MULTIPLE_MANUFACTURERS_BRANDS_STATUS_UPDATE_BULK',
  CACHE_CLEAR_FOR_BRAND_STATUS_UPDATE_BULK: 'CACHE_CLEAR_FOR_BRAND_STATUS_UPDATE_BULK',
  DISTRIBUTOR_IMAGE_DELETION: 'DISTRIBUTOR_IMAGE_DELETION',
  MANUFACTURER_IMAGE_DELETION: 'MANUFACTURER_IMAGE_DELETION',
  ENGAGED_MANUFACTURERS_GMV_REPORT: 'ENGAGED_MANUFACTURERS_GMV_REPORT',
  DISTRIBUTORS_GMV_REPORT: 'DISTRIBUTORS_GMV_REPORT',
  DISTRIBUTOR_PRODUCT_DELETION: 'DISTRIBUTOR_PRODUCT_DELETION',
  MANUFACTURER_PRODUCT_DELETION: 'MANUFACTURER_PRODUCT_DELETION',
  GDSN_PRODUCT_WITHDRAWAL: 'GDSN_PRODUCT_WITHDRAWAL',
  MFR_SCORE_GAP_REPORT: 'MFR_SCORE_GAP_REPORT',
  DP_PARTNER_VENDOR_GMV_REFRESH: 'DP_PARTNER_VENDOR_GMV_REFRESH',
  JOB_EXECUTION: 'JOB_EXECUTION',
  ASSIGN_USDA_ATTRIBUTES: 'ASSIGN_USDA_ATTRIBUTES',
  DELETE_USDA_ATTRIBUTES: 'DELETE_USDA_ATTRIBUTES',
};

const TaskTypeOptions = [
  {
    value: TaskType.ATTRIBUTE_ASSIGNMENT,
    label: 'ATTRIBUTE_ASSIGNMENT',
  },
  { value: TaskType.ATTRIBUTE_EXPORT_FOR_PRODUCT_LIST, label: 'ATTRIBUTE_EXPORT_FOR_PRODUCT_LIST' },
  { value: TaskType.ATTRIBUTE_EXPORT_TO_SNOWFLAKE_S3, label: 'ATTRIBUTE_EXPORT_TO_SNOWFLAKE_S3' },
  { value: TaskType.ATTRIBUTE_MIGRATION, label: 'ATTRIBUTE_MIGRATION' },
  { value: TaskType.ATTRIBUTE_SCHEMA_ASSIGNMENT, label: 'ATTRIBUTE_SCHEMA_ASSIGNMENT' },
  { value: TaskType.ASSIGN_THUMBNAILS, label: 'ASSIGN_THUMBNAILS' },
  {
    value: TaskType.BATCH_ATTRIBUTE_PROPAGATION_REQUEST,
    label: 'BATCH_ATTRIBUTE_PROPAGATION_REQUEST',
  },
  { value: TaskType.BROKEN_IMAGE_DELETE, label: 'BROKEN_IMAGE_DELETE' },
  {
    value: TaskType.CACHE_CLEAR_FOR_BRAND_STATUS_UPDATE,
    label: 'CACHE_CLEAR_FOR_BRAND_STATUS_UPDATE',
  },
  {
    value: TaskType.CACHE_CLEAR_FOR_VENDOR_OVERRIDE_FROM_MFR_CHANGED,
    label: 'CACHE_CLEAR_FOR_VENDOR_OVERRIDE_FROM_MFR_CHANGED',
  },
  {
    value: TaskType.CACHE_CLEAR_FOR_VENDOR_TRUSTED_SOURCE_UPDATE,
    label: 'CACHE_CLEAR_FOR_VENDOR_TRUSTED_SOURCE_UPDATE',
  },
  {
    value: TaskType.CD_DATA_IMPORT,
    label: 'CD_DATA_IMPORT',
  },
  { value: TaskType.DATA_EXPORT_TO_C_N_D, label: 'DATA_EXPORT_TO_C_N_D' },
  { value: TaskType.DATA_SOURCE_PREPROCESSED_EXPORT, label: 'DATA_SOURCE_PREPROCESSED_EXPORT' },
  { value: TaskType.DATA_SOURCE_SYNC, label: 'DATA_SOURCE_SYNC' },
  { value: TaskType.DATA_SOURCE_RECURRING_SYNC, label: 'DATA_SOURCE_RECURRING_SYNC' },
  { value: TaskType.DEMO_CATALOG_CREATION, label: 'DEMO_CATALOG_CREATION' },
  { value: TaskType.INTEGRATION_EXPORT, label: 'INTEGRATION_EXPORT' },
  { value: TaskType.IMAGE_CLEANUP, label: 'IMAGE_CLEANUP' },
  { value: TaskType.P0_SYNC_TO_C_AND_D, label: 'P0_SYNC_TO_C_AND_D' },
  { value: TaskType.PRODUCT_LINK_FROM_CHAINS, label: 'PRODUCT_LINK_FROM_CHAINS' },
  { value: TaskType.NUTRITION_PANEL_UPLOAD, label: 'NUTRITION_PANEL_UPLOAD' },
  { value: TaskType.PRODUCT_LIST_METRIC_COUNT, label: 'PRODUCT_LIST_METRIC_COUNT' },
  { value: TaskType.PRODUCT_STATUS_UPDATE, label: 'PRODUCT_STATUS_UPDATE' },
  { value: TaskType.REFRESH_CACHE_FOR_PRODUCT_LIST, label: 'REFRESH_CACHE_FOR_PRODUCT_LIST' },
  { value: TaskType.STATS_CALCULATION, label: 'STATS_CALCULATION' },
  { value: TaskType.UPB_PRODUCT_SCORE_UPDATE, label: 'UPB_PRODUCT_SCORE_UPDATE' },
  { value: TaskType.INDEXING_ATTRIBUTE_VALUES, label: 'INDEXING_ATTRIBUTE_VALUES' },
  { value: TaskType.ASSIGNING_UPB_SKUS, label: 'ASSIGNING_UPB_SKUS' },
  { value: TaskType.MANUFACTURER_PRODUCT_CREATION, label: 'MANUFACTURER_PRODUCT_CREATION' },
  { value: TaskType.CD_THUMBNAIL_EXPORT, label: 'CD_THUMBNAIL_EXPORT' },
  {
    value: TaskType.CONVERTING_MFR_PRODUCTS_TO_DISTRIBUTOR_PRODUCTS,
    label: 'CONVERTING_MFR_PRODUCTS_TO_DISTRIBUTOR_PRODUCTS',
  },
  { value: TaskType.INDEX_MFR_PRODUCTS, label: 'INDEX_MFR_PRODUCTS' },
  {
    value: TaskType.MANUFACTURER_PRODUCT_ENRICHMENT_EXPORT,
    label: 'MANUFACTURER_PRODUCT_ENRICHMENT_EXPORT',
  },
  {
    value: TaskType.ATTRIBUTE_EXPORT_FOR_DATA_SOURCE,
    label: 'ATTRIBUTE_EXPORT_FOR_DATA_SOURCE',
  },
  {
    value: TaskType.GDSN_MONITOR,
    label: 'GDSN_MONITOR',
  },
  {
    value: TaskType.DASHBOARD_WIDGET_CALCULATION,
    label: 'DASHBOARD_WIDGET_CALCULATION',
  },
  {
    value: TaskType.CACHE_CLEAR_FOR_MULTIPLE_MANUFACTURERS_BRANDS_STATUS_UPDATE_BULK,
    label: 'CACHE_CLEAR_FOR_MULTIPLE_MANUFACTURERS_BRANDS_STATUS_UPDATE_BULK',
  },
  {
    value: TaskType.CACHE_CLEAR_FOR_BRAND_STATUS_UPDATE_BULK,
    label: 'CACHE_CLEAR_FOR_BRAND_STATUS_UPDATE_BULK',
  },
  {
    value: TaskType.GDSN_PRODUCT_WITHDRAWAL,
    label: 'GDSN_PRODUCT_WITHDRAWAL',
  },
  {
    value: TaskType.MFR_SCORE_GAP_REPORT,
    label: 'MFR_SCORE_GAP_REPORT',
  },
  {
    value: TaskType.DP_PARTNER_VENDOR_GMV_REFRESH,
    label: 'DP_PARTNER_VENDOR_GMV_REFRESH',
  },
  {
    value: TaskType.JOB_EXECUTION,
    label: 'JOB_EXECUTION',
  },
  {
    value: TaskType.ASSIGN_USDA_ATTRIBUTES,
    label: 'ASSIGN_USDA_ATTRIBUTES',
  },
  {
    value: TaskType.DELETE_USDA_ATTRIBUTES,
    label: 'DELETE_USDA_ATTRIBUTES',
  },
];

export { TaskStatus, TaskStatusOptions, TaskType, TaskTypeOptions };
